import { createFileRoute } from "@tanstack/react-router";
import Motociclete from "@/pages/Motociclete";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/motociclete/")({
  head: () => routeHead("/uk/motociclete/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Motociclete />
  );
}
